import { render } from "./Datatype-Select.vue?vue&type=template&id=9d7d9da8&scoped=true"
import script from "./Datatype-Select.vue?vue&type=script&lang=js"
export * from "./Datatype-Select.vue?vue&type=script&lang=js"

import "./Datatype-Select.vue?vue&type=style&index=0&id=9d7d9da8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\OneDrive\\工作案件\\前端管理介面\\vue3-adminlte3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d7d9da8"]])

export default __exports__